import React, { useEffect, useRef, useState } from 'react'
import { lockIconFunc } from '../../../images/icon'
import { fetchFreePreviewTime } from '../../Hardwall/helper'
import { subscribeBlockPreviewWall } from '../Events/monetisation.events'
import { subscribeRenderUpdatedTimer, unsubscribeRenderUpdatedTimer } from '../Events/preview.events'
import { subscribeVideoError } from '../Events/utils.events'

const PreviewSecurityWall = ({ isSeries, metadataMap, styles, brandColors, layoutSettings,videoData }) => {

    let freePreview = window?.app_data?.appcmsMain?.features?.free_preview
    let isFreePreviewMultiplier = freePreview?.previewRestriction?.multiplier * 60
    const [isFreePreviewEnabled,setIsFreePreviewEnabled] = useState(false)
    const [updatedPreviewTime, setUpdatedPreviewTime] = useState(null)
    const [remainingPreviewTime,setRemainingPreviewTime] = useState()
    const progressRef = useRef(null)
    const { gamePlayerpreviewTitleStyles, gamePlayerpreviewDescriptionStyles } = styles

    const handleupdatingTimer = (data) => {
        if (data?.haultTimer) {
            unsubscribeRenderUpdatedTimer(handleupdatingTimer)
            setUpdatedPreviewTime(1)
            return
        }
            setUpdatedPreviewTime(data)
            if (progressRef.current) {
                let percent = Math.floor((data / isFreePreviewMultiplier) * 100)
                progressRef.current.style.width = `${percent}%`
            }
    }

    const handleVideoError = (data) => {
        if (data) {
            setIsFreePreviewEnabled(false)
        }
    }
    const formatSecondsAsTime = (seconds) => {
        const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
        const remainingSeconds = String(seconds % 60).padStart(2, '0');
        return `${minutes}:${remainingSeconds}`;
    }
    
    useEffect(() => {
        setRemainingPreviewTime(formatSecondsAsTime(updatedPreviewTime))
    },[updatedPreviewTime])

    const handleToBlockPreview = (data) => {
        setIsFreePreviewEnabled(data)
    }

    useEffect(() => {
        subscribeBlockPreviewWall(handleToBlockPreview)
    let freePreview = window?.app_data?.appcmsMain?.features?.free_preview
        setIsFreePreviewEnabled(freePreview?.isFreePreview)
        let {remainingPreviewTime} = fetchFreePreviewTime()
        setUpdatedPreviewTime(remainingPreviewTime)
        subscribeRenderUpdatedTimer(handleupdatingTimer)
        subscribeVideoError(handleVideoError)
    },[])
    return (<>
        {isFreePreviewEnabled ? <div className='preview-container' style={{background : brandColors?.overlayColor}}>
            <div className='preview-content'>
                {
                    isSeries ?
                        <>
                            <div className='preview-content-heading' style={gamePlayerpreviewTitleStyles}>{ updatedPreviewTime > 1 ? videoData?.title : metadataMap?.freePreviewEndedText}</div>
                            <div className='preview-content-description' style={gamePlayerpreviewDescriptionStyles}>{updatedPreviewTime > 1 ? metadataMap?.freePreviewText : metadataMap?.previewSubscriptionText}</div>
                        </>
                        : <>
                            <div className='preview-content-heading' style={gamePlayerpreviewTitleStyles}>{updatedPreviewTime > 1 ? metadataMap?.hardwallBannerTitle : metadataMap?.hardwallBannerEndedTitle}</div>
                            <div className='preview-content-description' style={gamePlayerpreviewDescriptionStyles}>{metadataMap?.hardwallBannerDescription}</div>
                        </>
                }
            </div>
            {updatedPreviewTime > 1 ?  <div className='preview-content-timer' style={{background : brandColors?.progressBgColor}}>
                <div className='progress' style={{background : brandColors?.activeBgColor}} ref={progressRef}></div><div className='lock-icon'>{lockIconFunc("#000")} <p style={gamePlayerpreviewTitleStyles}>{remainingPreviewTime}</p></div>
            </div>: <>
            <div className='preview-content-timer' style={{background : brandColors?.progressBgColor}}>
                <div className='progress' style={{background : brandColors?.progressBgColor}}></div><div className='lock-icon'>{lockIconFunc("#000")}</div>
            </div>
            </>}
        </div> : <></>}
    </>)
}

export default PreviewSecurityWall